import { parsePhoneNumberFromString } from "libphonenumber-js/max";

/**
 * Validates a mobile number given as a separate country calling code (e.g.
 * "65" for Singapore, "62" for Indonesia) and national number. Returns true
 * when countryCallingCode or nationalNumber is missing — the `required`
 * form rule is responsible for rejecting empty input, not this check.
 */
export function isValidMobileNumber(
  countryCallingCode: string | undefined,
  nationalNumber: string | undefined,
): boolean {
  if (!countryCallingCode || !nationalNumber) return true;
  if (!/^\d+$/.test(nationalNumber)) return false;

  const phone = parsePhoneNumberFromString(
    `+${countryCallingCode}${nationalNumber}`,
    "SG",
  );
  return !!phone && phone.isValid();
}
